import { Component, Input, OnInit } from '@angular/core';
import { EventEmitter, Output } from '@angular/core';
import { ShuttleBox } from '../../class/shuttle-box/shuttle-box';

@Component({
  selector: 'app-shuttle-box',
  templateUrl: './shuttle-box.component.html',
  styleUrls: ['./shuttle-box.component.less'],
})
export class ShuttleBoxComponent implements OnInit {
  @Input() shuttle_box: ShuttleBox;
  @Output() newItemEvent = new EventEmitter<string>();
  current_menu_id = 1;
  addNewItem(value: string): void {
    this.newItemEvent.emit(value);
  }
  switchTab(id: number): void {
    this.current_menu_id = id;
  }
  selectedTag(tag: any): void {
    let existing = false;
    this.shuttle_box.selected_tab_list.forEach((value) => {
      if (value === tag) {
        existing = true;
      }
    });
    if (!existing) {
      this.shuttle_box.selected_tab_list.push(tag);
    }
    const str = JSON.stringify(this.shuttle_box.selected_tab_list);
    this.addNewItem(str);
  }
  handleClose(tag: any): void {
    this.shuttle_box.selected_tab_list = this.shuttle_box.selected_tab_list.filter((tag1) => tag1 !== tag);
  }
  clearSelected(): void {
    this.shuttle_box.selected_tab_list = [];
  }
  constructor() {}
  ngOnInit(): void {}
}
